"use client"

import { createContext, useContext, useState, type ReactNode } from "react"

type ActivitySidebarContextType = ReturnType<typeof useActivitySidebar>

const ActivitySidebarContext = createContext<ActivitySidebarContextType | null>(null)

export function ActivitySidebarProvider({ children }: { children: ReactNode }) {
  const sidebar = useActivitySidebar()
  return <ActivitySidebarContext.Provider value={sidebar}>{children}</ActivitySidebarContext.Provider>
}

export function useSidebarContext() {
  const context = useContext(ActivitySidebarContext)
  if (!context) {
    throw new Error("useSidebarContext must be used within SidebarProvider")
  }
  return context
}

export function useActivitySidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const [sidebarTab, setSidebarTab] = useState("cards")

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const openSidebar = () => {
    setSidebarOpen(true)
  }

  const closeSidebar = () => {
    setSidebarOpen(false)
  }

  const openAIChat = () => {
    setSidebarOpen(true)
    setSidebarTab("chat")
  }

  return {
    sidebarOpen,
    sidebarTab,
    toggleSidebar,
    openSidebar,
    closeSidebar,
    openAIChat,
    setSidebarTab,
  }
}
